var AlligatorView, Backbone, SupportEmailFormModel, SupportLegacyOrderBanner, SupportMerchantContactView, SupportProgressBarView, SupportUtilsHelper, SupportV1StepThreeBaseView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportEmailFormModel = require('../../models/email_form');

AlligatorView = require('../../../../shared/frontend/views/alligator_view');

SupportUtilsHelper = require('../../helpers/utils');

SupportLegacyOrderBanner = require('../legacy_order_banner_view');

SupportProgressBarView = require('../progress_bar_view');

SupportMerchantContactView = require('../common/views/merchant_contact_view.coffee');

Backbone = require('backbone');

Backbone.$ = $;

SupportV1StepThreeBaseView = (function(superClass) {
  extend(SupportV1StepThreeBaseView, superClass);

  function SupportV1StepThreeBaseView() {
    return SupportV1StepThreeBaseView.__super__.constructor.apply(this, arguments);
  }

  SupportV1StepThreeBaseView.prototype.className = 'horizontal step-three';

  SupportV1StepThreeBaseView.prototype.initialize = function() {
    if (Groupon.Support.MAXINDEX === 2) {
      this.id = 2;
    } else {
      this.id = 3;
    }
    this.emailFormModel = new SupportEmailFormModel;
    this.emailFormMainView = this.getEmailFormView({
      emailFormModel: this.emailFormModel
    });
    this.contactChannelView = this.configureContactChannelView({
      mainView: this,
      emailFormModel: this.emailFormModel
    });
    this.merchantContactView = new SupportMerchantContactView({
      mainView: this
    });
    return this.shouldRenderEmailForm = false;
  };

  SupportV1StepThreeBaseView.prototype.postRenderhandler = function() {
    if (this.shouldShowContactChannelView()) {
      return this.handleDisplayOfContactChannels();
    } else {
      return Groupon.Support.ContentModel.onInitStepThree();
    }
  };

  SupportV1StepThreeBaseView.prototype.handleDisplayOfContactChannels = function() {
    return this.contactChannelView.handleDisplayOfContactChannels();
  };

  SupportV1StepThreeBaseView.prototype.showPriorityView = function(priorityView, shouldRenderEmailForm) {
    window.showFooterLinks();
    this.shouldRenderEmailForm = shouldRenderEmailForm;
    priorityView.render();
    this.$el.html(priorityView.$el);
    this.renderProgressBar();
    return this.renderLiveChat();
  };

  SupportV1StepThreeBaseView.prototype.render = function() {
    var ref, ref1, ref2;
    AlligatorView.hideWidgets();
    if ((ref = Groupon.Support.ContentModel) != null ? ref.isRefundEligible : void 0) {
      return this.showPriorityView(this.emailFormMainView, true);
    } else if ((ref1 = Groupon.Support.currentOrder) != null ? ref1.isChannelEligibleForMerchantContact : void 0) {
      return this.showPriorityView(this.merchantContactView, false);
    } else if ((ref2 = Groupon.Support.ContentModel) != null ? ref2.escalateToMerchant : void 0) {
      return this.showPriorityView(this.emailFormMainView, true);
    } else if (this.shouldShowContactChannelView()) {
      return this.renderContactChannelView();
    } else {
      return this.showPriorityView(this.emailFormMainView, true);
    }
  };

  SupportV1StepThreeBaseView.prototype.renderContactChannelView = function() {
    this.hideComponents();
    this.contactChannelView.render();
    this.$el.html(this.contactChannelView.el);
    this.renderProgressBar();
    this.renderLegacyOrderBanner();
    return this.contactChannelView.renderLiveChat();
  };

  SupportV1StepThreeBaseView.prototype.isPhonePreferredChannel = function() {
    return this.emailFormMainView.isPhonePreferredChannel();
  };

  SupportV1StepThreeBaseView.prototype.renderEmailForm = function() {
    return propagateEventBeforeReplacingElements((function(_this) {
      return function() {
        return _this.emailClickCallback();
      };
    })(this));
  };

  SupportV1StepThreeBaseView.prototype.emailClickCallback = function() {
    this.shouldRenderEmailForm = true;
    this.emailFormMainView.contactByEmail();
    this.$el.html(this.emailFormMainView.$el);
    this.renderProgressBar();
    return this.postEmailFormRenderCallBack();
  };

  SupportV1StepThreeBaseView.prototype.postEmailFormRenderCallBack = function() {};

  SupportV1StepThreeBaseView.prototype.renderPhoneNumberView = function() {};

  SupportV1StepThreeBaseView.prototype.submitFormHandler = function() {};

  SupportV1StepThreeBaseView.prototype.shouldShowContactChannelView = function() {};

  SupportV1StepThreeBaseView.prototype.hideComponents = function() {
    return SupportUtilsHelper.hideFloatingBoldChat();
  };

  SupportV1StepThreeBaseView.prototype.renderProgressBar = function() {
    var progressBar;
    progressBar = new SupportProgressBarView;
    progressBar.render();
    return this.$el.find('.steps-container').append(progressBar.el);
  };

  SupportV1StepThreeBaseView.prototype.renderLegacyOrderBanner = function() {
    var legacyOrderBanner;
    legacyOrderBanner = new SupportLegacyOrderBanner;
    legacyOrderBanner.render();
    return this.$el.find('.legacy-order-banner').append(legacyOrderBanner.el);
  };

  SupportV1StepThreeBaseView.prototype.renderLiveChat = function(params) {
    var liveChatMode, liveChatType;
    if (params == null) {
      params = {};
    }
    liveChatMode = params.liveChatMode || Groupon.Support.LiveChatModel.getDefaultStepThreeLiveChatMode();
    if (liveChatMode != null) {
      if (window.evaluate(this.shouldRenderEmailForm)) {
        liveChatType = Groupon.Support.LiveChatModel.getDefaultLiveChatType();
      }
      Groupon.Support.LiveChatView.setLiveChat(liveChatMode, liveChatType || params.liveChatType);
      Groupon.Support.LiveChatView.renderView(this.$el, $.extend(true, this.emailFormMainView.getChatParams(), {
        startFromSameViewState: params.startFromSameViewState
      }));
      if (isStaticLiveChat(liveChatMode)) {
        return SupportUtilsHelper.hideFloatingBoldChat();
      } else {
        return SupportUtilsHelper.showFloatingBoldChat();
      }
    }
  };

  SupportV1StepThreeBaseView.prototype.renderChatClickView = function() {};

  SupportV1StepThreeBaseView.prototype.isFlexibleContactEnabled = function() {
    var ref;
    return window.evaluate((ref = window.experiments) != null ? ref.showFlexibleContactChannels : void 0);
  };

  SupportV1StepThreeBaseView.prototype.isOptimizedContactEnabled = function() {
    return window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showOptimizedContactChannel : void 0);
  };

  return SupportV1StepThreeBaseView;

})(Backbone.View);

module.exports = SupportV1StepThreeBaseView;

//# sourceMappingURL=data:application/json;base64,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
